import { useEffect } from 'react';
import { mobileViewport } from '../constants';

export const useViewportOverrideEffect = () => {
  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    const defaultViewport = viewport?.getAttribute('content');

    viewport?.setAttribute('content', mobileViewport);

    return () => {
      if (defaultViewport) {
        viewport?.setAttribute('content', defaultViewport);
      }
    };
  }, []);
};
